import { render, staticRenderFns } from "./ResourceLibrary.vue?vue&type=template&id=3403a66c&"
import script from "./ResourceLibrary.vue?vue&type=script&lang=js&"
export * from "./ResourceLibrary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports